import { render, staticRenderFns } from "./Talon.vue?vue&type=template&id=29c0f741"
import script from "./Talon.vue?vue&type=script&lang=js"
export * from "./Talon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports